export default __webpack_public_path__ + "static/media/segment.f0c7dedf.svg";